/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
import React from "react";
import dayjs from "dayjs";
import "dayjs/locale/ca";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

dayjs.locale("ca");

const CustomDatePicker = ({
  name,
  label,
  selectedDate,
  handleInputChange,
  dateFormat = "DD/MM/YYYY",
  size = "medium",
}) => {
  // Convertir selectedDate string a objeto dayjs o null
  const dateValue = selectedDate ? dayjs(selectedDate, dateFormat) : null;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} locale="ca">
      <DatePicker
        label={label}
        value={dateValue}
        onChange={(newValue) => handleInputChange(name, newValue)}
        format={dateFormat}
        slotProps={{
          textField: {
            size: size,
            id: `id-${name}`,
            name: name,
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default CustomDatePicker;

